import { render, staticRenderFns } from "./ModalFood.vue?vue&type=template&id=30aed3ac&scoped=true&"
import script from "./ModalFood.vue?vue&type=script&lang=js&"
export * from "./ModalFood.vue?vue&type=script&lang=js&"
import style0 from "./ModalFood.vue?vue&type=style&index=0&id=30aed3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aed3ac",
  null
  
)

export default component.exports